import Filter from 'bad-words'

// bad-words' clean() splits a text at word boundaries (/\b/), replaces each piece its isProfane()
// flags and joins the pieces again. isProfane() builds and runs a RegExp for every word on its
// list (about 450) for each piece, so a whole program took about 0.1 s per 1-2K characters - per
// text, and the experiment Overview's replay shows a new program at every keystroke. A piece's
// verdict depends on the piece alone, so one filter is shared and each piece's verdict kept: the
// same pieces, the same replacements, the same text as clean() gives (profanityFilter.test.js).
const filter = new Filter()
const verdicts = new Map()
// Verdicts kept at most; then they start again (a text's pieces are mostly words of the language
// and the code's names, so this is rarely reached).
const MAX_VERDICTS = 50000

const isProfanePiece = (piece) => {
  let verdict = verdicts.get(piece)
  if (verdict === undefined) {
    verdict = filter.isProfane(piece)
    if (verdicts.size >= MAX_VERDICTS) verdicts.clear()
    verdicts.set(piece, verdict)
  }
  return verdict
}

export const filterProfanity = (userInput) => {
  if (/[a-zA-Z]/g.test(userInput) === false) {
    return userInput
  }
  if (/^\*+$/.test(userInput)) {
    return userInput
  }
  // filter.clean(userInput), piece by piece (its join is '', the empty match of /\b/).
  return userInput
    .split(/\b/)
    .map((piece) => (isProfanePiece(piece) ? filter.replaceWord(piece) : piece))
    .join('')
}
